import moment from "moment";

import { SessionExtra } from "../../store/Session/SessionModel";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";

// import {
//   GetNormalizedState,
//   NormalizedState
// } from "../../store/Session/helper/NormalizedValues";
import "./style.css";

interface Props {
  sessionData: SessionExtra;
}

// const NormalizedConditions = (sessionData: SessionExtra) => {
//   var normalizedState = false;
//   var normalizedAlwaysOn = false;
//   switch (GetNormalizedState(sessionData)) {
//     case NormalizedState.alwaysOn:
//       normalizedState = true;
//       normalizedAlwaysOn = true;
//       break;
//     case NormalizedState.enabled:
//       normalizedState = true;
//       break;
//     case NormalizedState.notSupported:
//     case NormalizedState.disabled:
//       normalizedState = false;
//   }
//   if (normalizedAlwaysOn || (normalizedState && sessionData.isNormalized)) {
//     return (
//       <>
//         <div className="gray">
//           <div className="icon-wrapper">
//             <div className="text-wrapper">mountains</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>{sessionData.elevation}</SkeletonLineWrapper>
//           </div>
//         </div>

//         <div className="gray">
//           <div className="icon-wrapper">
//             <div className="icon-2">temperature-half</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>
//               {sessionData.temperatureConverted}
//             </SkeletonLineWrapper>
//           </div>
//         </div>

//         <div className="gray">
//           <div className="icon-wrapper">
//             <div className="icon-2">golf-ball-tee</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>
//               {sessionData.normalizedBallType}
//             </SkeletonLineWrapper>
//           </div>
//         </div>
//       </>
//     );
//   } else {
//     return (
//       <>
//         <div className="gray">
//           <div className="icon-wrapper disabled">
//             <div className="text-wrapper">mountains</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>N/A</SkeletonLineWrapper>
//           </div>
//         </div>

//         <div className="gray">
//           <div className="icon-wrapper disabled">
//             <div className="icon-2">temperature-half</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>N/A</SkeletonLineWrapper>
//           </div>
//         </div>

//         <div className="gray">
//           <div className="icon-wrapper disabled">
//             <div className="icon-2">golf-ball-tee</div>
//           </div>
//           <div className="text">
//             <SkeletonLineWrapper>N/A</SkeletonLineWrapper>
//           </div>
//         </div>
//       </>
//     );
//   }
// };

// const SessionLocationIcon = (sessionData: SessionExtra) => {
//   if (sessionData.location) {
//     return `/img/fs_icon-${sessionData.location.toLowerCase()}.svg`;
//   }
//   return "/img/fs_icon-outdoor.svg";
// };

const SessionLocation = ({ sessionData }: Props): JSX.Element => {
  return (
    <>
      <div className="location-time">
        <div className="location">
          {sessionData.address && (
            <img
              className="icon-location-pin"
              alt=""
              src="/img/fs_icon-locationpin.png"
            />
          )}
          <div className="place">
            <SkeletonLineWrapper width="200px">
              {sessionData.address}
            </SkeletonLineWrapper>
          </div>
        </div>
        <div className="date-time">
          <SkeletonLineWrapper>
            {moment.unix(sessionData.startTimestamp).format("MMM D, YYYY")}
          </SkeletonLineWrapper>
        </div>
      </div>
    </>
  );
};

export default SessionLocation;
